import { useTranslation } from 'react-i18next';

import { useActionInput } from '../../../context';

export const useNotationText = () => {
	const { validator } = useActionInput();
	const { t } = useTranslation('action_input');

	if (!validator) {
		return null;
	}

	if (validator.requireHashtag && validator.requireAmount) {
		return {
			required: t('validation.optional_fields.none.required'),
			optional: null,
		};
	}

	if (validator.requireAmount) {
		return {
			optional: t('validation.optional_fields.hashtag.optional'),
			required: t('validation.optional_fields.hashtag.required'),
		};
	}

	if (validator.requireHashtag) {
		return {
			optional: t('validation.optional_fields.amount.optional'),
			required: t('validation.optional_fields.amount.required'),
		};
	}

	return {
		optional: t('validation.optional_fields.hashtag_amount.optional'),
		required: t('validation.optional_fields.hashtag_amount.required'),
	};
};
